import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { RefreshCw } from 'lucide-react';

interface VersionData {
    version: string;
    timestamp: number;
}

export const VersionCheck: React.FC = () => {
    const [hasUpdate, setHasUpdate] = useState(false);

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await fetch('/version.json?t=' + new Date().getTime());
                if (!response.ok) return;

                const data: VersionData = await response.json();
                const localVersion = localStorage.getItem('app_version');
                const localTimestamp = localStorage.getItem('app_version_timestamp');

                if (localVersion && data.version !== localVersion) {
                    setHasUpdate(true);
                    showUpdateToast();
                } else if (!localVersion) {
                    // First load, save version
                    localStorage.setItem('app_version', data.version);
                    localStorage.setItem('app_version_timestamp', data.timestamp.toString());
                }
            } catch (error) {
                console.error('Failed to check version', error);
            }
        };

        // Check immediately on mount
        checkVersion();

        // Check every 60 seconds
        const interval = setInterval(checkVersion, 60000);

        return () => clearInterval(interval);
    }, []);

    const showUpdateToast = () => {
        toast((t) => (
            <div className="flex items-center gap-3 rtl:space-x-reverse">
                <div className="bg-blue-100 dark:bg-blue-900/30 p-2 rounded-full text-blue-600 dark:text-blue-400">
                    <RefreshCw size={20} className="animate-spin-slow" />
                </div>
                <div className="flex-1">
                    <p className="font-semibold text-slate-800 dark:text-slate-100">تحديث جديد متاح</p>
                    <p className="text-sm text-slate-600 dark:text-slate-400">يتوفر إصدار جديد من النظام</p>
                </div>
                <button
                    onClick={() => {
                        toast.dismiss(t.id);
                        window.location.reload();
                    }}
                    className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
                >
                    تحديث
                </button>
            </div>
        ), {
            duration: Infinity,
            position: 'bottom-left',
            style: {
                background: 'transparent',
                boxShadow: 'none',
                padding: 0,
            },
        });
    };

    return null;
};
